import * as Yup from 'yup'

const fastSellProductOutboundFormSchema = Yup.object().shape({
  outbound_courier: Yup.string().required(
    'Outbound courier harus diisi'
  ),
  outbound_shipping_no: Yup.string().required(
    'Outbound shipping no harus diisi'
  )
})

export default fastSellProductOutboundFormSchema
